// extracted by mini-css-extract-plugin
module.exports = {"container":"UpdateAvailable_container__1k1L6","status":"UpdateAvailable_status__2KngE","heading":"UpdateAvailable_heading__1SOcv"};